import ViewArticle from "./ViewArticle";

export default ViewArticle